const apiConfig = {
    //apiUrl: 'https://localhost:7102/api/',
    apiUrl: 'https://pf-api.off-ease.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;


